import { FC, useEffect, useState } from 'react'
import {
  DragDropContext,
  Droppable,
  Draggable,
  DropResult,
} from 'react-beautiful-dnd'
import styled from 'styled-components'

import { CourseOutlineTask, Outline, courseApi } from 'packages/sdks-next/growp'
import { dragReorder } from 'packages/utils'

import { Task } from './Task'

/**
 * 可拖拽任务列表
 *
 * @param param0 - param0
 * @param param0.tasks - 任务列表
 * @param param0.outlines - 大纲列表
 * @param param0.outlineId - 大纲id
 * @returns component
 */
export const DraggableTasks: FC<{
  tasks: CourseOutlineTask[]
  outlines: Outline[]
  outlineId?: number
}> = ({ tasks, outlines, outlineId }) => {
  const [dragItems, setDragItems] = useState<
    (CourseOutlineTask & { name?: string; id: number; weight?: number })[]
  >([])

  const { api: batchSortOutlineTask } = courseApi.useBatchSortOutlineTask({
    reload: [courseApi.loadCourseActivityTask],
  })

  const onDragEnd = async (result: DropResult) => {
    if (!result.destination) {
      return
    }

    const newItems = dragReorder(
      dragItems,
      result.source.index,
      result.destination.index
    )

    setDragItems(newItems)
    await batchSortOutlineTask(newItems)
  }

  useEffect(() => {
    const editableGroups = tasks.map((g, idx) => ({
      ...g,
      id: g.id,
      name: g.name,
      weight: idx,
    }))

    setDragItems(editableGroups)
  }, [tasks])

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable">
        {(provided) => (
          <Tasks
            {...provided.droppableProps}
            ref={provided.innerRef}
          >
            {dragItems.map((item, index) => (
              <Draggable
                key={item.id}
                draggableId={String(item.id)}
                index={index}
              >
                {(provided) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    style={provided.draggableProps.style}
                  >
                    <Task
                      task={item}
                      outlineId={outlineId}
                      outlines={outlines}
                    />
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </Tasks>
        )}
      </Droppable>
    </DragDropContext>
  )
}

const Tasks = styled.div``
